import { useMutation } from "@tanstack/react-query";
import { MediaAPI } from "../api";

export const useCreateMedia = () => {
  return useMutation({
    mutationFn: (formData) => MediaAPI.createMedia(formData),
    onError: (error) => {
      console.error("Create Media Failed: ", error.response || error);
    },
  });
};

export const useCreateAdminMedia = () => {
  return useMutation({
    mutationFn: (formData) => MediaAPI.createAdminMedia(formData),
    onError: (error) => {
      console.error("Create Media Failed: ", error.response || error);
    },
  });
};
